import localForage from 'localforage';

export default {
  async SET_LISTADO_EMPRESAS(state, payload) {
    const empresas = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < payload.empresas.length; i++) {
      const empresa = payload.empresas[i];
      if (empresa.esEmisor || empresa.esReceptor) {
        empresas.push(empresa);
      }
    }
    state.empresas = empresas;
    const { Empresas } = await localForage.getItem(process.env.VUE_APP_AMBIENTE);
    Empresas.empresa = state.empresas.find((e) => e.id === Empresas.empresa.id);
    if (!Empresas.empresa) return;
    this.commit('Empresas/SET_EMPRESA', Empresas.empresa);
  },
  SET_EMPRESA(state, payload) {
    state.empresa.id = payload.id;
    state.empresa.razonSocial = payload.razonSocial;
    state.empresa.fantasia = payload.fantasia;
    state.empresa.iut = payload.iut;
    state.empresa.estado = payload.estado;
    state.empresa.esEmisor = payload.esEmisor;
    state.empresa.esReceptor = payload.esReceptor;
    state.empresa.esCanal = payload.esCanal;
    state.empresa.canal = payload.canal;
    state.empresa.esRcof = payload.esRcof;
    state.empresa.reglasNegocio = payload.reglasNegocio;
    state.empresa.estadoEmpresa = payload.estadoEmpresa;
    state.empresa.firmaSimple = payload.firmaSimple;
    state.empresa.firmaAvanzada = payload.firmaAvanzada;
    // Restaurar settings desde caché por empresa (si existe), en vez de vaciar.
    // Esto permite que el menú use el valor cacheado de forma instantánea.
    // fetchCompanySetting refresca el valor en segundo plano después.
    state.settings = state.settingsCache[payload.iut] || {};
    this.commit('List/RESET_USERS', null, { root: true });
  },
  SET_DOMAIN_COMPANY(state, company) {
    state.empresa = company;
  },
  SET_USER_SIGN(state, payload) {
    state.userSigns = payload.firmas;
    state.advancedSign = payload.puedeFirmarAvanzada;
    state.simpleSign = payload.puedeFirmarSimple;
  },
  SET_USERS_COMPANY(state, payload) {
    state.usersCompany = payload.usuarios;
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  SET_USERS_COMPANY_ASSIGN(state, payload) {
    state.usersCompanyAssign = payload.usuarios;
  },
  SET_GROUPS_COMPANY(state, payload) {
    state.groupsCompany = payload;
  },
  SET_USERS_GROUP(state, payload) {
    state.usersGroup = payload.usuarios;
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  UPDATE_GROUP(state, payload) {
    const updatedGroup = {
      ...payload,
      name: payload.nombre
    };

    if (updatedGroup.meta && Object.keys(updatedGroup.meta).length) {
      updatedGroup.oficinaInterna = updatedGroup.meta.oficina_int;
      updatedGroup.oficinaExterna = updatedGroup.meta.oficina_ext;
    }
    state.groupsCompany = state.groupsCompany.map((group) => {
      if (group.id === updatedGroup.id) {
        return {
          ...updatedGroup
        };
      }
      return group;
    });
  },
  ADD_GROUP(state, payload) {
    const group = payload;
    group.isDivision = payload.esDivision === 'Y';
    group.isOffice = payload.esOficina === 'Y';
    state.groupsCompany = [...state.groupsCompany, group];
  },
  REMOVE_GROUP(state, groupId) {
    state.groupsCompany = state.groupsCompany.filter((group) => group.id !== groupId);
  },
  ADD_USER_GROUP(state, payload) {
    // TODO agregar al grupo el id del usuario?
    state.usersGroup = [
      ...state.usersGroup,
      payload
    ];
  },
  SET_LIDER_GROUP(state, payload) {
    state.usersGroup = state.usersGroup.map((user) => {
      const userMap = user;
      if (userMap.id === payload.usuarioId) {
        userMap.esLider = payload.esLider;
        return userMap;
      }
      if (userMap.id === payload.reemplazoId) {
        userMap.esLider = 'N';
        return userMap;
      }
      return user;
    });

    state.groupsCompany = state.groupsCompany.map((group) => {
      const groupMap = group;
      if (groupMap.id === payload.grupoId) {
        groupMap.tieneLider = payload.esLider;
        return groupMap;
      }
      return groupMap;
    });
  },
  REMOVE_USER_GROUP(state, payload) {
    state.usersGroup = state.usersGroup.filter((userFilter) => userFilter.id !== payload.id);
  },
  UPDATE_USER(state, payload) {
    state.usersGroup = state.usersGroup.map((user) => {
      if (user.id === payload.id) {
        return payload;
      }
      return user;
    });

    state.usersCompany = state.usersCompany.map((user) => {
      if (user.id === payload.id) {
        return payload;
      }
      return user;
    });
  },
  ADD_USER(state, payload) {
    state.usersGroup = [
      ...state.usersGroup,
      payload
    ];

    state.usersCompany = [
      ...state.usersCompany,
      payload
    ];
  },
  REMOVE_USER(state, usuarioId) {
    state.usersGroup = state.usersGroup.filter((user) => user.id !== usuarioId);
    state.usersCompany = state.usersCompany.filter((user) => user.id !== usuarioId);
  },
  SET_CONFIGURATIONS(state, payload) {
    state.configurations = payload;
  },
  SET_LOAD_CONFIGURATIONS(state, payload) {
    state.isLoadingConfigurations = payload;
  },
  SET_SAVING_CONFIGURATIONS(state, payload) {
    state.isSavingConfigurations = payload;
  },
  SET_SUCCESS_MESSAGE(state, payload) {
    state.successAction = payload;
  },
  SET_SUBSTITUTES_USER(state, payload) {
    state.substitutes = payload;
  },

  SAVE_SUBSTITUTE_USER(state, payload) {
    state.substitutes = state.substitutes.map((substitute) => {
      if (substitute.remplazoId === payload.remplazoId) {
        return payload;
      }
      return substitute;
    });
  },
  SET_LIST(
    state,
    {
      target,
      company,
      value
    }
  ) {
    if (company) {
      if (!state.list[company]) {
        state.list[company] = {};
      }
      if (!state.list[company][target]) {
        state.list[company][target] = {};
      }
      state.list[company][target].list = value;
    } else {
      if (!state.list[target]) {
        state.list[target] = {};
      }
      state.list[target].list = value;
    }
  },
  SET_LIST_LOADING(
    state,
    {
      target,
      company,
      value
    }
  ) {
    if (company) {
      if (!state.list[company]) {
        state.list[company] = {};
      }
      if (!state.list[company][target]) {
        state.list[company][target] = {};
      }
      state.list[company][target].loading = value;
    } else {
      if (!state.list[target]) {
        state.list[target] = {};
      }
      state.list[target].loading = value;
    }
  },
  SET_SETTINGS_LOADING(
    state,
    settingsLoading
  ) {
    state.settingsLoading = settingsLoading;
  },
  SET_SETTINGS(
    state,
    {
      settings
    }
  ) {
    state.settings = {
      ...state.settings,
      ...settings
    };
    // Guardar en caché por empresa para restauración instantánea
    if (state.empresa.iut) {
      state.settingsCache[state.empresa.iut] = { ...state.settings };
    }
  }
};
